export const wizardContainerClasses = `
    py-8
`

export const wizardButtonContainerClasses = `
    flex
    justify-center
    items-baseline
    gap-4
    p-6
`
